import React from "react";
import style from "../Style.module.css";

const Pattern4 = ({ color = "#2F2F2F", ...props }) => {
  return (
    <svg
      height="100%"
      viewBox="0 20 312 356"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
      className={style.svgBackground}
    >
      <path
        d="M312 162V-14.5H234H156V162C156 118.877 121.037 84 78 84C34.8766 84 0 118.963 0 162V240H78C34.8766 240 0 274.963 0 318V396H156V318C156 361.123 190.963 396 234 396C277.123 396 312 361.037 312 318V240H234C277.123 240 312 205.037 312 162ZM156 240V318C156 274.877 121.037 240 78 240H156V162C156 205.123 190.963 240 234 240H156Z"
        fill={color}
        opacity={0.1}
      />
    </svg>
  );
};

export default Pattern4;
